import AriaAct from "@resources/aria-act/AriaAct";

document.addEventListener('DOMContentLoaded', function() {
	const classToObserve = 'atonal-accordion__head';
	AriaAct.registerListener('click',`.${classToObserve}`,'expandToggle')
	window.addEventListener("AriaAct:expandOpen", (e) => {
		if( !e.detail.trigger.classList.contains(classToObserve) ) return;
		AriaAct.closeOthersOnOpen(e.detail)
		const margin = {top: document.querySelector('.topbar')?.clientHeight + 50};
		AriaAct.maybeScrollTo(e.detail,550, true, margin )
	});
});
